import type { ComponentProps } from 'react';
import { cn } from '../../common/functions/cn';
import EmptyFieldLabel from './empty-field-label';

interface ReadOnlyValueProps extends ComponentProps<'div'> {
  /** Renders the shared empty placeholder in place of the children. */
  isEmpty?: boolean;
}

/** A field's value where its control would otherwise sit, at the same text size. */
export const ReadOnlyValue = ({ isEmpty, className, children, ...props }: ReadOnlyValueProps) => {
  return (
    <div className={cn(!isEmpty && 'py-1', 'text-base md:text-sm', className)} {...props}>
      {isEmpty ? <EmptyFieldLabel /> : children}
    </div>
  );
};
